/**
 * Mock pending-timesheet data for the "Approving for" feature.
 *
 * When a user selects a delegated approver from the "Approving for:" dropdown,
 * we show that approver's pending queue. Until the real API is wired up, these
 * static fixtures stand in for the backend response.
 */

import type { ApprovalRow } from '@/components/ApprovalGrid';

/** Returns the most-recent Sunday relative to today. */
function lastSunday(): Date {
  const d = new Date();
  d.setDate(d.getDate() - ((d.getDay() + 7) % 7 || 7));
  d.setHours(0, 0, 0, 0);
  return d;
}

/** Builds a minimal ApprovalRow — only the fields the grid actually renders. */
function makeRow(
  id: number,
  employeeId: number,
  employeeName: string,
  department: string,
  totalHours: number,
  approverId: number,
  approverIdStr: string,
  approverName: string,
): ApprovalRow {
  const weekEnd = lastSunday();
  return {
    timesheet: {
      id,
      employeeId,
      employeeName,
      weekEnding: weekEnd,
      status: 'submitted',
      entries: [],
      submittedAt: new Date(weekEnd.getTime() - 24 * 60 * 60 * 1000), // Saturday
      approverId,
      approverName,
      companyId: 'demo',
    },
    employeeName,
    department,
    weekEnding: weekEnd,
    totalHours,
    policyViolations: [],
    anomalyResult: undefined,
    isOverdue: false,
    photoUrl: `https://picsum.photos/seed/${employeeName.replace(' ', '-')}-${employeeId}/300/300`,
    delegationManagerId: approverIdStr,
    delegationManagerName: approverName,
  };
}

/** John Davis's pending approval queue. */
export const JOHN_DAVIS_APPROVAL_ROWS: ApprovalRow[] = [
  makeRow(90001, 9001, 'Alex Chen',  'Cloud Services',           37.5, 8001, 'john-davis', 'John Davis'),
  makeRow(90002, 9002, 'Lisa Ray',   'Application Development',  40.0, 8001, 'john-davis', 'John Davis'),
];

/** Matt Brown's pending approval queue (empty for demo purposes). */
export const MATT_BROWN_APPROVAL_ROWS: ApprovalRow[] = [];

/** Look up mock rows by approver id. */
export const MOCK_APPROVER_ROWS: Record<string, ApprovalRow[]> = {
  'john-davis': JOHN_DAVIS_APPROVAL_ROWS,
  'matt-brown': MATT_BROWN_APPROVAL_ROWS,
};
